Pixlee.module("SocialAuthApp.Show", function(Show, App, Backbone, Marionette, $) {

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        id: "social_auth_widget",
        ui: {
            socialSignInContainer: '#social_sign_in_container',
            emailSignUpContainer: '#email_sign_up_container',
            emailInputText: '#email_input_text',
            error: '.error',
            validate: '.validate',
            signInFacebook: '#sign_in_facebook',
            // signInInstagram: '#sign_in_instagram',
            signInTwitter: '#sign_in_twitter',
            signInEmail: '#sign_in_email',
            backSocialLogin: '#back_social_login',
            emailDoneButton: '#email_done_button'
        },
        events: {
            'click @ui.signInFacebook': 'signInFacebook',
            // 'click @ui.signInInstagram': 'signInInstagram',
            'click @ui.signInTwitter': 'signInTwitter',
            'click @ui.signInEmail': 'signInEmail',
            'click @ui.backSocialLogin': 'backSocialLogin',
            'click @ui.emailDoneButton': 'emailDone',
            'keyup @ui.emailInputText': 'clearErrors'
        },
        signInFacebook: function() {
            App.execute('facebook:login:photos', function(social_login) {
                this.processCollection('facebook', social_login);
            }.bind(this));
        },
        // signInInstagram: function() {
        //     App.execute('instagram:login:photos', function(social_login) {
        //         this.processCollection('instagram', social_login);
        //     }.bind(this));
        // },
        signInTwitter: function() {
            App.execute('twitter:login:photos', function(social_login) {
                this.processCollection('twitter', social_login);
            }.bind(this));
        },
        signInEmail: function() {
            this.ui.socialSignInContainer.hide();
            this.ui.emailSignUpContainer.show();
        },
        backSocialLogin: function() {
            this.ui.socialSignInContainer.show();
            this.ui.emailSignUpContainer.hide();
        },
        clearErrors: function() {
            this.ui.error.hide();
            this.ui.validate.hide();
        },
        emailDone: function() {
            var email = this.ui.emailInputText.val().trim();
            if (!email.length) {
                this.ui.error.show();
            } else if (!this.validateEmail(email)) {
                this.ui.validate.show();
            } else {
                this.processCollection('email', email);
            }
        },
        validateEmail: function(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        processCollection: function(platform, social_login) {

            var data = {
                platform: platform,
                social_login: social_login
            };
            var message = {
                name: "pixlee:social:login",
                type: 'relay',
                source: 'social',
                destination: 'widget',
                data: data
            };

            window.parent.postMessage(JSON.stringify(message), '*');

            if ('parentIFrame' in window) {
                setTimeout(function() {
                    window.parentIFrame.close();
                }, 50);

            }
        },
        onShow: function() {
            var _this = this;
            if ('ontouchstart' in window) {
                $('#widget').addClass('social_auth_mobile');
            }

            var message = {
                name: "pixlee:social:login:loaded",
                type: 'relay',
                source: 'social',
                destination: 'widget',
                data: {}
            };

            window.parent.postMessage(JSON.stringify(message), '*');

            $(document.body).on('click touchend', '#close', function(e) {
                if ('parentIFrame' in window) {
                    window.parentIFrame.close();
                }
            });
        }
    });
});